import { Action, Toast } from './types';

export const initialState: Toast[] = [];

export const reducer = (state: Toast[], action: Action): Toast[] => {
  switch (action.type) {
    case 'SHOW_TOAST':
      return [...state, action.payload];
    case 'HIDE_TOAST':
      return state.filter((toast) => toast.id !== action.payload.id);
    default:
      return state;
  }
};
